export const languageStringsPopups = {
  deletionWasSuccessful: "Odstranění proběhlo úspěšně.",
  saveWasSuccessful: "Úspěšně uloženo",
  visualChanged: "Vzhled byl nastaven úspěšně.",
  notificationAdded: "Notifikace byla přidána.",
  setButtonText: "Nastavte text tlačítka.",
  missingHttp: 'Url musí mít "http" a nebo "https" na začátku.',
  addNameAndText: "Přidejte název notifikace a text.",
  textMustBeFilled: "Text notifikace musí být vyplněný.",
  connectionMissing: 'Musíte splnit alespoň jednu položku ve "Spárování".',
  added: "Přidáno.",
  fillAllFields: "Vyplňte všechna pole",
  fillApiKey: "Zadejte API klič",
  webCreatedSuccessfully: "Web byl úspěšně vytvořen.",
  notVerified: "Není ověřeno",
  changesSaved: "Změny byly úspěšně uloženy",
  changeSubscriptionDisabled: "Změna podmínek předplatného je zakázána",
  subscriptionChangedTo: "Předplatné změněno na: ",
  subscriptionCanceled: "Předplatné úspěšně zrušeno",
  nameIsEmpty: "Jméno nemůže být prázdné",
  cannotCreateNotification: "Nepodařilo se vytvořit notifikaci.",
  fillApiAndPlaceId: "Zadejte API klíč a Place ID.",
  verificationFailed: "Ověření selhalo.",
  apiKeyVerificatedSuccess: "API klíč byl úspěšně ověřen.",
  fillApiAndBusinessUnitId: "Zadejte API klíč a Business Unit ID.",
  googleReviewsWasVerified: "Google Reviews byl úspěšně ověřen.",
};
